var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRemoveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.170067 0.169278C0.376209 -0.0359074 0.698787 -0.0545606 0.926099 0.113318L0.991223 0.169278L6 5.15455L11.0088 0.169278C11.2149 -0.0359074 11.5375 -0.0545606 11.7648 0.113318L11.8299 0.169278C12.0361 0.374463 12.0548 0.695544 11.8862 0.921802L11.8299 0.986623L6.41058 6.38083C6.20444 6.58601 5.88186 6.60467 5.65455 6.43679L5.58942 6.38083L0.170067 0.986623C-0.056689 0.76092 -0.056689 0.394982 0.170067 0.169278Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8299 11.8307C11.6238 12.0359 11.3012 12.0546 11.0739 11.8867L11.0088 11.8307L6 6.84545L0.991223 11.8307C0.785081 12.0359 0.462503 12.0546 0.235191 11.8867L0.170067 11.8307C-0.0360745 11.6255 -0.054815 11.3045 0.113847 11.0782L0.170067 11.0134L5.58942 5.61917C5.79556 5.41399 6.11814 5.39533 6.34545 5.56321L6.41058 5.61917L11.8299 11.0134C12.0567 11.2391 12.0567 11.605 11.8299 11.8307Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemoveIcon);
export default __webpack_public_path__ + "static/media/remove-icon.561986c05d8d3f12120b8a8548666292.svg";
export { ForwardRef as ReactComponent };